<template>
  <div>
    <el-dialog
      title="编辑座位号"
      :visible.sync="dialogVisible"
      width="280px"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="8">
          <span style="vertical-align:-5px;">座位号：</span>
        </el-col>
        <el-col :span="14">
          <el-input size="mini" v-model="SeatNumber" type="number" placeholder="请填写座位号"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submit">保 存</el-button>
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SeatNumber: null,
      dialogVisible: false,
    };
  },
  methods: {
    open(num) {
      this.SeatNumber = num || null;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    submit() {
      if (!(this.SeatNumber > 0 && this.SeatNumber % 1 == 0)) {
        this.$message.error("座位号需为数字，且大于0");
        return false;
      }
      this.$emit("setSeat", this.SeatNumber);
    },
    handleClose() {},
  },
};
</script>

<style>
</style>